import { AxiosInstance } from 'axios';
import { BUCKET_URL, FILE_PATH } from './api-consts';
import { ParsedStatuses } from '../utils/types';
// FAKE DATA FOR QA PURPOSES
// import * as FakeData from './fake-uptime-data.json';

/**
 * Fetches uptime data from the GCS bucket
 */
export const fetchUptimeData = async (
  bucketApi: AxiosInstance
): Promise<ParsedStatuses | null> => {
  // the purpose of adding a numerical to the request is to prevent the browser from always caching the response.
  // if 2 requests are made with the SAME timestamp, the browser will use a cached response.
  const thirtySecondIntervals = Math.round((Date.now() / 1000 / 60) * 2);
  try {
    const result = await bucketApi.get<ParsedStatuses>(
      `${BUCKET_URL}${FILE_PATH}?time=${thirtySecondIntervals}`
    );
    return result.data;
    // RETURN FAKE DATA FOR QA PURPOSES
    // return JSON.parse(JSON.stringify(FakeData));
  } catch (error) {
    console.error(error);
    return null;
  }
};
